import { Select } from '@bigcommerce/big-design';
import '../../CustomerInfoSection.css';

export default function CountriesDropdown(props) {
	const { getValue, setValue } = props;
	const countries = [
		{ value: 'United States', content: 'United States' },
		{ value: 'Canada', content: 'Canada' },
	];

	return (
		<Select
			filterable={true}
			label="Country"
			options={countries}
			value={getValue('country')}
			onOptionChange={(value) => setValue('country', value)}
			placement={'bottom-start'}
			required
		/>
	);
}
